import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

// A living canvas: chrome-less, muted, endlessly looping, its edges dissolving into the black.
const CDN = "https://vz-d0322ae1-337.b-cdn.net/ac70261a-c29f-4add-b891-85098d0a987a";
const MASK = "linear-gradient(to right, transparent 0%, #000 20%, #000 80%, transparent 100%), linear-gradient(to bottom, transparent 0%, #000 18%, #000 82%, transparent 100%)";
const MASK_STYLE = { WebkitMaskImage: MASK, maskImage: MASK, WebkitMaskComposite: "source-in", maskComposite: "intersect" };

export default function SomaticMirror() {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    v.muted = true;
    v.defaultMuted = true;
    const play = () => v.play().catch(() => {});
    const io = new IntersectionObserver(([e]) => (e.isIntersecting ? play() : v.pause()), { threshold: 0.05 });
    io.observe(v);
    v.addEventListener("canplay", play);
    return () => { io.disconnect(); v.removeEventListener("canplay", play); };
  }, []);

  return (
    <motion.div
      data-testid="somatic-mirror"
      initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
      className="relative mx-auto mt-40 aspect-video w-full max-w-5xl md:mt-56"
      style={MASK_STYLE}
    >
      <video
        ref={ref}
        data-testid="somatic-mirror-video"
        className="living-canvas pointer-events-none absolute inset-0 h-full w-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        disablePictureInPicture
        disableRemotePlayback
        controlsList="nodownload nofullscreen noremoteplayback"
        poster={`${CDN}/thumbnail.jpg`}
        aria-hidden="true"
        tabIndex={-1}
        onContextMenu={(e) => e.preventDefault()}
      >
        <source src={`${CDN}/play_1080p.mp4`} type="video/mp4" />
        <source src={`${CDN}/play_720p.mp4`} type="video/mp4" />
      </video>
    </motion.div>
  );
}
